import { NavigationLinkClasses } from 'components/NavigationLink';
import { getColor } from 'helpers';
import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

export const ContainerStyled = styled(Stack)(({ theme }) => ({
  [`.${NavigationLinkClasses.activeLink}`]: {
    '.navigationMenu-link': {
      color: getColor(theme, {
        dark: ColorsDark.blue150,
        light: ColorsLight.blue150,
      }),
      fontWeight: '700',
    },
  },
}));
